import * as types from './actionTypes'
import { fleetPagination } from '../../utils/constants'

export const initialState = {
  vehicles: [],
  hasMoreVechiles: true,
}

const Fleet = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_FLEET: {
      if (payload.pagination) {
        return {
          ...state,
          vehicles: [...state.vehicles, ...payload.result],
          hasMoreVechiles: payload.result.length >= fleetPagination,
        }
      }
      return {
        ...state,
        vehicles: payload.result,
        hasMoreVechiles: payload.result.length >= fleetPagination,
      }
    }
    default:
      return state
  }
}

export default Fleet
